import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatCard } from '@angular/material/card';
import { PageLayoutComponent } from '@app/components/shared/page-layout/page-layout.component';
import { PageTitleComponent } from '@app/components/common/page-title/page-title.component';
import { ImportRaceDataComponent } from '@app/components/manager/import-race-data/import-race-data.component';

@Component({
  selector: 'faxe-manager',
  imports: [
    FormsModule,
    MatCard,
    PageLayoutComponent,
    PageTitleComponent,
    ReactiveFormsModule,
    ImportRaceDataComponent
  ],
  templateUrl: './manager.component.html',
  styleUrl: './manager.component.scss'
})
export class ManagerComponent {

  formGroup: UntypedFormGroup = this.formBuilder.group({});

  constructor(private readonly formBuilder: UntypedFormBuilder) {
  }


}
